import { combineReducers } from 'redux';
import ExternalEvidenceReducer from './ExternalEvidenceReducer';
import UiConfigReducer from './UiConfigReducer';

export default combineReducers({
    externalEvidence: ExternalEvidenceReducer,
    uiConfig: UiConfigReducer
});
